// Vendor libraries
import { createAction, props } from '@ngrx/store';
// TODO: create types for the possible options
export const setDataFormatAggregation = createAction('[Scatter Plot] Set Data Format Aggregation', props());
export const setDataFormatFillMethod = createAction('[Scatter Plot] Set Data Format FillMethod', props());
export const setDataFormatFrequency = createAction('[Scatter Plot] Set Data Format Frequency', props());
